/**
 * 침대 개수 문구. 0이거나 없는 종류는 빼고 공백으로 잇는다. 모두 없으면 빈 문자열.
 * 예) [['싱글', 1], ['퀸', 0], ['킹', 2]] → "싱글 1 킹 2" (separator가 ''이면 "싱글1 킹2")
 */
export const formatBedCounts = (
  beds: Array<[label: string, count: number | null | undefined]>,
  separator = ' ',
): string =>
  beds
    .filter(([, count]) => Number(count) > 0)
    .map(([label, count]) => `${label}${separator}${count}`)
    .join(' ');

/** 면적이 있을 때만 true(0이거나 없으면 화면에 표시하지 않는다). */
export const hasArea = (size: number | string | null | undefined): boolean => Number(size) > 0;
